export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fba91219bf364895b0a042decbae87ab7ea40a1b7&name=fetchTypeahead!'